import { t } from '../../../shared/config/translations'
import { type CollectionLayout, nextCollectionLayout } from './collectionLayout'

// Bundled Lucide rows-3, list and layout-grid SVG paths (ISC license).
const icons: Record<CollectionLayout, string> = {
	default:
		'<rect width="18" height="18" x="3" y="3" rx="2"/><path d="M21 9H3M21 15H3"/>',
	compact: '<path d="M3 5h.01M3 12h.01M3 19h.01M8 5h13M8 12h13M8 19h13"/>',
	cover: '<rect width="7" height="7" x="3" y="3" rx="1"/><rect width="7" height="7" x="14" y="3" rx="1"/><rect width="7" height="7" x="14" y="14" rx="1"/><rect width="7" height="7" x="3" y="14" rx="1"/>',
}

export function collectionLayoutButtonTemplate(
	layout: CollectionLayout,
): string {
	const label = `${t('collection.layoutLabel')}: ${t(`collection.layout_${layout}`)}. ${t('collection.layoutSwitch')}: ${t(`collection.layout_${nextCollectionLayout(layout)}`)}`
	return `<button type="button" id="col-layout-button"
		class="btn noFrame icon filter-icon-button" aria-label="${label}" title="${label}">
		<svg data-layout-icon="${layout}" viewBox="0 0 24 24" fill="none" stroke="currentColor"
			stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${icons[layout]}</svg>
	</button>`
}
